var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddImageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.12859 13.0238L7.13126 8.74414L12.6512 13.9892",
    stroke: "#AFAFAF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27732 22.0814H3.38372C2.84269 22.0814 2.32381 21.8664 1.94124 21.4839C1.55867 21.1013 1.34375 20.5824 1.34375 20.0414V3.72161C1.34375 3.18058 1.55867 2.6617 1.94124 2.27913C2.32381 1.89657 2.84269 1.68164 3.38372 1.68164H19.7035C20.2445 1.68164 20.7634 1.89657 21.146 2.27913C21.5285 2.6617 21.7435 3.18058 21.7435 3.72161V8.35078",
    stroke: "#AFAFAF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6119 9.60076C16.6952 9.60076 17.5734 8.72256 17.5734 7.63925C17.5734 6.55593 16.6952 5.67773 15.6119 5.67773C14.5286 5.67773 13.6504 6.55593 13.6504 7.63925C13.6504 8.72256 14.5286 9.60076 15.6119 9.60076Z",
    stroke: "#AFAFAF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6115 18.6065V20.9547M20.6115 20.9547V23.3029M20.6115 20.9547H22.9597M20.6115 20.9547H18.2633M27.6561 20.9547C27.6561 21.8799 27.4739 22.7959 27.1198 23.6506C26.7658 24.5053 26.2469 25.2819 25.5928 25.936C24.9386 26.5902 24.162 27.1091 23.3073 27.4631C22.4526 27.8171 21.5366 27.9993 20.6115 27.9993C19.6864 27.9993 18.7703 27.8171 17.9156 27.4631C17.0609 27.1091 16.2844 26.5902 15.6302 25.936C14.9761 25.2819 14.4572 24.5053 14.1031 23.6506C13.7491 22.7959 13.5669 21.8799 13.5669 20.9547C13.5669 19.0864 14.3091 17.2946 15.6302 15.9735C16.9513 14.6524 18.7431 13.9102 20.6115 13.9102C22.4798 13.9102 24.2716 14.6524 25.5928 15.9735C26.9139 17.2946 27.6561 19.0864 27.6561 20.9547Z",
    stroke: "#AFAFAF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImageIcon);
export default __webpack_public_path__ + "static/media/add-image-icon.973ae9176f103efd7899c633548bbe78.svg";
export { ForwardRef as ReactComponent };